import { SET_SIDEBAR } from './types'

export const setSidebar = (payload) => ({
  type: SET_SIDEBAR,
  payload,
})
